import axios, {AxiosError, AxiosRequestConfig, AxiosResponse} from 'axios'

export const useHttp = () => {

    const http = axios.create({
        baseURL: '/api',
        headers: {
            'Authorization': 'Bearer 3yDrMg9GmY8dApiT',
            'Accept': 'application/json',
        }
    })

    const get = <T>(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        return request('get', url, payload, config)
    }

    const post = <T>(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        return request('post', url, payload, config)
    }

    const put = <T>(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        return request('put', url, payload, config)
    }

    const patch = <T>(url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {
        return request('patch', url, payload, config)
    }

    const destroy = <T>(url: string, config?: AxiosRequestConfig): Promise<T> => {
        return request('delete', url, config)
    }

    const request = <T>(method: any, url: string, payload?: Record<string, any>, config?: AxiosRequestConfig): Promise<T> => {

        const requestConfig: AxiosRequestConfig = {
            url: url,
            method,
            [method === 'get' ? 'params' : 'data']: payload,
            ...config
        }

        return new Promise<T>((resolve, reject) => {
            http.request(requestConfig)
                .then((response: AxiosResponse) => {
                    resolve(response.data as T)
                })
                .catch((error: AxiosError) => {
                    if (error.response?.status !== 422) {
                        /*
                         * @TODO
                         */
                    }
                    reject(error.response)
                })
        })
    }

    return {
        get,
        post,
        put,
        patch,
        destroy,
        request
    }
}
